import { gql } from "@apollo/client";

const AvailableProjects = gql`
  query AvailableProjects {
    allProjects(condition: { isActive: true }, orderBy: PROJECT_NAME_ASC) {
      nodes {
        projectName
      }
    }
  }
`;

const hash = "af0b6ee9d045caec1428bdbbed388259989740a3f5ec947d48589df74dda0075";

export { AvailableProjects, hash };
